/* eslint-disable */
import _ from 'underscore'
import uniqid from 'uniqid'
import axios from 'axios'
import qs from 'querystring'

const guid = function() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  )
}

export default {
  state: {},
  mutaions: {},
  actions: {
    pay({}, data) {
      return new Promise((resolve) => {
        const link = 'https://rixtrema.net/payment/index.html#'
        let price = ''
        if (data.type === 1) {
          price = '4995'
        } else {
          price = '12995'
        }

        let id =
          data.type === 1
            ? 'LARKSPURELITEPLANACCELERATOR'
            : 'LARKSPURELITEPLANACCELERATORPLATINUM'
        let options = `${guid()}|||${data.email}|||${data.firstName} ${
          data.lastName
        }|||${price}|||${id}|||1|||12m|||0|||1|||12|||`
        // LARKSPURELITEPLANACCELERATORPLATINUM

        const paymentData = window.btoa(options)
        const finalLink = `${link}${paymentData}`
        resolve(finalLink)
      })
    },
    logUser({}, form) {
      const data = {
        action: 'QUESTIONNAIREANSWER',
        userId: uniqid(),
        uid: 'accelerator',
        answer: JSON.stringify({ ...form }),
        ip: '',
        refferer: '',
        date: '202011231508',
      }

      return axios.get(
        'https://rixtrema.net/RixtremaWS/AJAXPCT.aspx?' +
          _.map(data, function(d, i) {
            return i + '=' + encodeURIComponent(d)
          }).join('&')
      )
    },
    sendEmail({}, data) {
      const form = `
      Email: ${data.email}
      Name: ${data.firstName} ${data.lastName}`
      const preparedForm = {
        action: 'SENDMAIL',
        nameFrom: 'new Elite Plan Advisor Accelerator',
        mailFrom: 'winbigplans@rixtrema.com',
        MailTo: 'winbigplans@rixtrema.com',
        mailCopy: '',
        mailSubject: encodeURIComponent(
          'New Elite Plan Advisor Accelerator Lead'
        ),
        mailMessage: encodeURIComponent(form),
        SystemType: 'BIONIX',
      }

      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }

      return axios.post(
        `https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx`,
        qs.stringify(preparedForm),
        config
      )
    },
  },
}
